export function roomFetch(
  userId: string,
  url: string,
  options: RequestInit = {},
) {
  return fetch(url, {
    credentials: 'same-origin',
    cache: 'no-store',
    ...options,
    headers: {
      ...Object.fromEntries(new Headers(options.headers)),
      'X-Bramble-Client': '2',
      'X-Bramble-Media': '1',
      'X-Bramble-User': userId,
    },
  })
}
export async function roomRequest<T>(
  userId: string,
  url: string,
  method = 'GET',
  body?: unknown,
): Promise<T> {
  const response = await roomFetch(userId, url, {
    method,
    ...(body !== undefined
      ? {
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body),
        }
      : {}),
  })
  const value = await response.json()
  if (!response.ok) {
    if (response.status === 401)
      window.dispatchEvent(new Event('bramble:unauthorized'))
    throw new Error(
      value.error || 'The writing room could not be reached. Try again.',
    )
  }
  return value as T
}
